// import * as actionTypes from './actions'

import { combineReducers } from 'redux'
import advertiser from './advertiserReducer'
import auth from './authReducer'
import page from './pageReducer'
import campaign from './campaignReducer'
import campaignEvents from './campaignEventReducer'
import customerLists from './customerListReducer'

export default combineReducers({
  r_advertiser: advertiser,
  r_page: page,
  r_auth: auth,
  r_campaignEvent: campaignEvents,
  r_campaign: campaign,
  r_customerList: customerLists
})
